<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid">
            <div class="md:col-8 sm:col-12 comp-grid">
              <div class="card">
                <div class="text-xl text-primary font-bold">Edit Fund</div>
              </div>
              <Breadcrumb
                :home="{
                  icon: 'pi pi-arrow-left text-lg mr-3',
                  label: 'Back',
                  command: () => {
                    $router.go(-1);
                  },
                }"
                :model="[
                  {
                    label: 'Funding Catalogue',
                    to: '/third_party_agencies_grants',
                  },
                  {
                    label: 'Edit',
                    to: '/third_party_agencies_grants/edit/' + id,
                  },
                ]"
              />
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-8 sm:col-12 comp-grid">
            <div class="card nice-shadow-18">
              <div>
                <template v-if="!loading">
                  <div class="grid">
                    <div class="col-12">
                      <form
                        ref="observer"
                        tag="form"
                        @submit.prevent="startRecordUpdate()"
                      >
                        <!--[form-content-start]-->
                        <div class="grid">
                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">Name *</div>
                            <div class="">
                              <check-duplicate
                                v-model="formData.grant_name"
                                check-path="components_data/third_party_agencies_grants_grant_name_exist/"
                                v-slot="checker"
                              >
                                <InputText
                                  ref="ctrlgrant_name"
                                  @blur="checker.check"
                                  :loading="checker.loading"
                                  v-model.trim="formData.grant_name"
                                  label="Name"
                                  type="text"
                                  placeholder="Enter Name"
                                  class="w-full"
                                  :class="getErrorClass('grant_name')"
                                >
                                </InputText>
                                <small
                                  v-if="!checker.loading && checker.exist"
                                  class="p-error"
                                >
                                  Not available</small
                                >
                                <small v-if="checker.loading" class="text-500"
                                  >Checking...</small
                                >
                              </check-duplicate>
                            </div>
                          </div>

                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">Type *</div>
                            <div class="">
                              <Dropdown
                                class="w-full"
                                :class="getErrorClass('grant_type')"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrlgrant_type"
                                v-model="formData.grant_type"
                                :options="$menus.grant_typeItems"
                                label="Type"
                                placeholder="Select ..."
                              >
                              </Dropdown>
                            </div>
                          </div>

                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">
                              Website Url
                            </div>
                            <div class="">
                              <InputText
                                ref="ctrlwebsite_url"
                                v-model.trim="formData.website_url"
                                label="Website Url"
                                type="text"
                                placeholder="http://www.website.com"
                                class="w-full"
                                :class="getErrorClass('website_url')"
                              >
                              </InputText>
                            </div>
                          </div>

                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">
                              Allocated Amount (GHS)
                            </div>
                            <div class="">
                              <InputText
                                ref="ctrlallocated_amount"
                                v-model.trim="formData.allocated_amount"
                                label="Allocated Amount"
                                type="number"
                                placeholder="0.00"
                                class="w-full"
                                :class="getErrorClass('allocated_amount')"
                              >
                              </InputText>
                            </div>
                          </div>

                          <div class="col-12 md:col-12">
                            <div class="mb-2 font-bold text-sm">
                              Brief Description
                            </div>
                            <div class="">
                              <Textarea
                                :class="getErrorClass('grant_description')"
                                class="w-full"
                                ref="ctrlgrant_description"
                                rows="3"
                                v-model="formData.grant_description"
                                placeholder="Brief Description"
                                type="textarea"
                              >
                              </Textarea>
                            </div>
                          </div>

                          <div class="col-12 md:col-12">
                            <div class="mb-2 font-bold text-sm">
                              Would applicant have to continue to provide
                              further application data on the
                              fund's/scholarship's website? *
                            </div>
                            <div class="">
                              <!-- <div class="field mb-0"> -->
                              <div
                                class="field-radiobutton"
                                v-for="option of $menus.yes_or_noItems"
                                :key="option.value"
                              >
                                <RadioButton
                                  :class="
                                    getErrorClass('has_additional_form_online')
                                  "
                                  :id="option.value"
                                  name="ctrlhas_additional_form_online"
                                  :value="option.value"
                                  v-model="formData.has_additional_form_online"
                                />
                                <label :for="option.value"
                                  >{{ option.label }}
                                </label>
                              </div>
                              <!-- </div> -->
                            </div>
                          </div>

                          <div class="col-12">
                            <hr />
                            <div class="mt-3">
                              <div
                                class="mb-1 mx-2 text-blue-500 font-bold text-md"
                              >
                                Additional Form Definition
                              </div>
                              <small class="mx-2 text-xs text-primary"
                                >You can add up to 10 additional form fields for
                                interested applicants to fill</small
                              >

                              <div class="mt-3">
                                <grantadditionalinfo-page
                                  is-sub-page
                                  ref="additional_form_definitionForm"
                                  :show-submit-button="false"
                                  v-if="ready"
                                  :additionalformdefinition="
                                    formData.additional_form_definition
                                  "
                                ></grantadditionalinfo-page>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--[form-content-end]-->
                        <div v-if="showSubmitButton" class="text-center my-3">
                          <Button
                            type="submit"
                            label="Update"
                            icon="pi pi-send"
                            :loading="saving"
                          />
                        </div>
                      </form>
                      <slot :submit="submit" :saving="saving"></slot>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="p-3 text-center">
                    <ProgressSpinner style="width: 50px; height: 50px" />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import grantadditionalinfoPage from "../third_party_agencies_grants/add_grant_additional_info.vue";
import { PageMixin } from "../../mixins/page.js";
import { EditPageMixin } from "../../mixins/editpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
  minValue,
  maxValue,
  numeric,
  integer,
  decimal,
  ipAddress,
} from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "editThirdpartyagenciesgrantsPage",
  components: { grantadditionalinfoPage },
  mixins: [PageMixin, EditPageMixin],
  props: {
    pageName: {
      type: String,
      default: "third_party_agencies_grants",
    },
    idName: {
      type: String,
      default: "third_party_agencies_grant_id",
    },
    routeName: {
      type: String,
      default: "third_party_agencies_grantsedit",
    },
    pagePath: {
      type: String,
      default: "third_party_agencies_grants/edit",
    },
    apiPath: {
      type: String,
      default: "third_party_agencies_grants/edit",
    },
  },
  data() {
    return {
      formData: {
        grant_name: "",
        grant_type: "",
        grant_description: "",
        additional_form_definition: "",
        website_url: "",
        allocated_amount: "",
        has_additional_form_online: "",
      },
      submitted: false,
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Edit Fund";
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["third_party_agencies_grants/currentRecord"];
      },
      set: function (value) {
        this.$store.commit(
          "third_party_agencies_grants/setCurrentRecord",
          value
        );
      },
    },
  },
  validations() {
    let formData = {
      grant_name: { required },
      grant_type: { required },
      grant_description: {},
      additional_form_definition: {},
      website_url: {},
      allocated_amount: {},
      has_additional_form_online: { required },
    };
    return { formData };
  },
  methods: {
    ...mapActions("third_party_agencies_grants", [
      "updateRecord",
      "fetchRecord",
    ]),
    async startRecordUpdate() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Please complete the form", "Form is invalid", "error");
        return;
      }
      this.saving = true;
      let id = this.id;
      let url = this.apiUrl;
      let payload = this.normalizedFormData();
      payload.additional_form_definition =
        this.$refs.additional_form_definitionForm.arrFormData;
      let data = { id, url, payload };
      this.updateRecord(data).then(
        (response) => {
          this.saving = false;
          this.flashMsg(this.msgAfterUpdate);
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          if (this.redirect) this.navigateTo(`/third_party_agencies_grants`);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    updateFormFields: function () {
      //update form fields value after load from api
      //e.g convert fieldvalue (value,value2,value2) to array
    },
    resetForm() {
      //reset form fields value
      this.formData = {
        grant_name: "",
        grant_type: "",
        grant_description: "",
        additional_form_definition: "",
        website_url: "",
        allocated_amount: "",
        has_additional_form_online: "",
      };
      //raise event to reset other custom form components
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      if (this.v$.formData[field].$invalid && this.submitted) {
        return "p-invalid";
      }
      return "";
    },
  },
  watch: {},
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
